import React, { FC } from 'react';
import dynamic from 'next/dynamic';
import { styled } from 'linaria/react';
import { useIntersectionObserver } from '@shared/lib';
import FullViewportHeightSection from './FullViewportHeightSection';
import SectionBg from './SectionBg';
import Title from './Title';
import Description from './Description';
import winnerDeterminationBgDesktop from '../../assets/new-year/winners-determination-bg-desktop.jpg';
import winnerDeterminationBgTablet from '../../assets/new-year/winners-determination-bg-tablet.jpg';
import winnerDeterminationBgMobile from '../../assets/new-year/winners-determination-bg-mobile.jpg';
import { newYearPrizes } from '../../config/new-year/prizes';
import PrizeItem from './PrizeItem';
const DynamicScrollDownAnimation = dynamic(() => import('./ScrollDownAnimation').then(imported => imported.default), {
  loading: () => <div />,
  ssr: false
});
const WinnerDeterminationSectionView: FC = () => {
  const [sectionRef, isSectionVisible] = useIntersectionObserver<HTMLDivElement>({
    threshold: 0.85,
    triggerOnce: true
  });
  return <FullViewportHeightSection>
      <SectionBg desktopImg={winnerDeterminationBgDesktop} tabletImg={winnerDeterminationBgTablet} mobileImg={winnerDeterminationBgMobile}>
        <WinnerDeterminationSectionViewWrapper ref={sectionRef}>
          <OpacityAnimation isSectionVisible={isSectionVisible}>
            <TextWrapper>
              <Title>Как выбираем победителей?</Title>
              <DescriptionWrapper>
                <Description>
                  <Medium>Главные призы</Medium>&nbsp;&mdash; топ-3 участников, совершивших больше всего пополнений.{' '}
                  <Medium>Дополнительные призы</Medium>&nbsp;&mdash; случайный выбор среди всех, кто сделал от&nbsp;3
                  платежей
                </Description>
              </DescriptionWrapper>
            </TextWrapper>
          </OpacityAnimation>
          <PrizesListWrapper isSectionVisible={isSectionVisible}>
            {newYearPrizes.map((prize, index) => <OpacityAnimation key={prize.label} isSectionVisible={isSectionVisible}>
                <PrizeItem index={index} prize={prize} />
              </OpacityAnimation>)}
          </PrizesListWrapper>
          <ScrollDownWrapper>
            <DynamicScrollDownAnimation />
          </ScrollDownWrapper>
        </WinnerDeterminationSectionViewWrapper>
      </SectionBg>
    </FullViewportHeightSection>;
};
export default WinnerDeterminationSectionView;
const WinnerDeterminationSectionViewWrapper = /*#__PURE__*/styled('div')({
  name: "WinnerDeterminationSectionViewWrapper",
  class: "w1ouzmu5",
  propsAsIs: false
});
const _exp = /*#__PURE__*/() => ({
  isSectionVisible
}) => isSectionVisible ? 'none' : 'translateY(60px)';
const _exp2 = /*#__PURE__*/() => ({
  isSectionVisible
}) => isSectionVisible ? '1' : '0';
const OpacityAnimation = /*#__PURE__*/styled('div')({
  name: "OpacityAnimation",
  class: "o1p5kakb",
  propsAsIs: false,
  vars: {
    "o1p5kakb-0": [_exp()],
    "o1p5kakb-1": [_exp2()]
  }
});
const TextWrapper = /*#__PURE__*/styled('div')({
  name: "TextWrapper",
  class: "t1mfe0r2",
  propsAsIs: false
});
const DescriptionWrapper = /*#__PURE__*/styled('div')({
  name: "DescriptionWrapper",
  class: "dcpf696",
  propsAsIs: false
});
const Medium = /*#__PURE__*/styled('span')({
  name: "Medium",
  class: "meq2qr1",
  propsAsIs: false
});
const PrizesListWrapper = /*#__PURE__*/styled('div')({
  name: "PrizesListWrapper",
  class: "p1yz7prn",
  propsAsIs: false
});
const ScrollDownWrapper = /*#__PURE__*/styled('div')({
  name: "ScrollDownWrapper",
  class: "s1399p7o",
  propsAsIs: false
});

require("./WinnerDeterminationSectionView.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./WinnerDeterminationSectionView.tsx");